// @ts-nocheck
import React from "react";
import {ListaAreas} from "./ListaAreas";
import {ProvideAreas} from "./State/ProvideAreas";

export const Areas = () => {

    return (
        <ProvideAreas>
            <ListaAreas></ListaAreas>
        </ProvideAreas>

    )
}